/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import Layout from "@/layout";

const parking = {
  path: "/parking",
  component: Layout,
  alwaysShow: true,
  name: "parking",
  meta: {
    title: "주차장 관리",
    icon: "parking",
  },
  children: [
    {
      path: "setting",
      component: () => import("@/views/parking/pakringMain.vue"),
      name: "parkingSetting",
      meta: { title: "주차장 설정" },
    },
    {
      path: "write",
      component: () => import("@/views/parking/detail/ParkingInsert.vue"),
      name: "parkingWrite",
    },
    {
      path: "rewrite",
      component: () => import("@/views/parking/detail/ParkingRewrite.vue"),
      name: "parkingRewrite",
    },
    {
      path: "coinSetting",
      component: () =>
        import(
          "@/views/parking/settingDefault/coinSetting/CoinSettingEditorMainManage.vue"
        ),
      name: "coinSetting",
    },
    {
      path: "coinSettingWrite",
      component: () =>
        import(
          "@/views/parking/settingDefault/coinSetting/CoinSettingWritePage.vue"
        ),
      name: "coinSettingWrite",
    },
    {
      path: "coinSettingView",
      component: () =>
        import(
          "@/views/parking/settingDefault/coinSetting/CoinSettingViewPage.vue"
        ),
      name: "coinSettingView",
    },
    {
      path: "facilitySetting",
      component: () =>
        import(
          "@/views/parking/settingDefault/facilitySetting/FacilitySettingEditorMainManage.vue"
        ),
      name: "facilitySetting",
    },
    {
      path: "facilitySettingWrite",
      component: () =>
        import(
          "@/views/parking/settingDefault/facilitySetting/FacilitySettingWritePage.vue"
        ),
      name: "facilitySettingWrite",
    },
    {
      path: "facilitySettingView",
      component: () =>
        import(
          "@/views/parking/settingDefault/facilitySetting/FacilitySettingViewPage.vue"
        ),
      name: "facilitySettingView",
    },
    {
      path: "historySetting",
      component: () =>
        import(
          "@/views/parking/settingDefault/historySetting/HistorySettingEditorMainManage.vue"
        ),
      name: "historySetting",
    },
    {
      path: "historySettingWrite",
      component: () =>
        import(
          "@/views/parking/settingDefault/historySetting/HistorySettingWritePage.vue"
        ),
      name: "historySettingWrite",
    },
    {
      path: "historySettingView",
      component: () =>
        import(
          "@/views/parking/settingDefault/historySetting/HistorySettingViewPage.vue"
        ),
      name: "historySettingView",
    },
  ],
};

export default parking;
